import React from 'react';
import styled from 'styled-components';
import { ColorNeutralBlack, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import dynamic from 'helpers/dynamic';
import { breakpoint, sizes } from 'variables';

const AuthorizedRetailerSVG = dynamic(() => import('icons/brands/chanel/authorizedRetailer.svg?react'), { ssr: false });

const Wrapper = styled.div`
    width: 100%;
    padding: ${Spacing8};
    border-top: 6px solid ${ColorNeutralBlack};
    text-align: center;

    ${breakpoint.up(sizes.md)} {
        padding: ${Spacing16};
        border-width: 8px;
    }
`;

const Image = styled(AuthorizedRetailerSVG)`
    width: 110px;
    height: 110px;

    ${breakpoint.up(sizes.md)} {
        width: 160px;
        height: 160px;
    }
`;

export default function ChanelFooter() {
    return (
        <Wrapper>
            <Image />
        </Wrapper>
    );
}
